import { ConsiderRegisterContainer } from "../../containers/RegisterSystem/ConsiderRegisterContainer"
export function ConsiderRegisterPage() {
    return (
        <ConsiderRegisterContainer />
    )
}